export default __webpack_public_path__ + "static/media/eonerc_rwth.438b4f1f.svg";